<template>
	<div class="all-wrap">
		<!-- 留言按钮 -->
		<Comment class="commentWrap" />
		<!-- 置顶组件 -->
		<gotop></gotop>

		<!-- 顶部 banner 区(站内框架,高度紧凑) -->
		<div class="videolist-banner">
			<Headernew />
			<div class="bannertop-title">
				<div>案例详情</div>
				<div>——后天科技·项目案例</div>
			</div>
		</div>

		<!-- 主体 -->
		<div class="app-container">
			<div class="breadcrumb">
				<span class="clickable" @click="goList">全部案例</span>
				<span class="sep">/</span>
				<span class="current">详情</span>
			</div>

			<!-- 版块标签：点击滚动跳转 -->
			<div class="section-tabs" v-if="detail">
				<button class="section-tab" @click="scrollToSection('sec-info')">基本信息</button>
				<button class="section-tab" v-if="detail.video_url" @click="scrollToSection('sec-video')">视频</button>
				<button class="section-tab" v-if="detail.image_url" @click="scrollToSection('sec-image')">图片</button>
				<button class="section-tab" v-if="detail.pdf_url" @click="scrollToSection('sec-pdf')">PDF</button>
				<button class="section-tab" v-if="detail.content" @click="scrollToSection('sec-content')">内容</button>
				<button class="section-tab" v-if="detail.text_intro" @click="scrollToSection('sec-text')">文字说明</button>
				<button class="section-tab" v-if="relatedRecords.length" @click="scrollToSection('sec-rel')">关联方案</button>
			</div>

			<div v-if="detail" class="detail-card" id="sec-info">
				<div class="detail-title"><i class="iconfont icon-Dmoxingx"></i> {{ detail.main }}</div>

				<div class="field" v-if="detail.keys_name"><span class="label">分类</span><span class="value">{{ detail.keys_name }}</span></div>
				<div class="field" v-if="detail.tags"><span class="label">标签</span><span class="value">{{ detail.tags }}</span></div>
				<div class="field" v-if="detail.type"><span class="label">类型</span><span class="value">{{ detail.type }}</span></div>
				<div class="field" v-if="detail.created_at"><span class="label">创建时间</span><span class="value">{{ detail.created_at }}</span></div>
				<div class="field" v-if="detail.link_url"><span class="label">外链</span><span class="value"><a :href="detail.link_url" target="_blank" rel="noopener noreferrer">{{ detail.link_url }}</a></span></div>
			</div>
			<div v-else class="empty-state"><i class="iconfont icon-dengdai"></i><p>未找到该案例</p></div>

			<!-- 媒体预览：分版块，有哪个显示哪个 -->
			<div class="media-block" v-if="detail">
				<div class="section-card" v-if="detail.video_url" id="sec-video">
					<div class="section-title"><i class="iconfont icon-shipinbofangyingpian"></i> 视频版块</div>
					<!-- 微信内置浏览器需加内联播放属性，否则可能无法播放 -->
					<video controls="controls" playsinline="true" webkit-playsinline="true" x5-playsinline="true"
						preload="metadata" controlslist="nodownload"
						:src="detail.video_url"
						style="width:100%;max-height:70vh;border-radius:8px;background:#000;"></video>
				</div>
				<div class="section-card" v-if="detail.image_url" id="sec-image">
					<div class="section-title"><i class="iconfont icon-dianying"></i> 图片版块</div>
					<img :src="detail.image_url" style="width:100%;border-radius:8px;display:block;">
				</div>
				<div class="section-card" v-if="detail.pdf_url" id="sec-pdf">
					<div class="section-title"><i class="iconfont icon-add"></i> PDF版块</div>
					<!-- 微信内核不支持 iframe 预览 PDF，改用 PDF.js canvas 渲染 -->
					<PdfViewer :src="detail.pdf_url" />
				</div>
				<div class="section-card" v-if="detail.content" id="sec-content">
					<div class="section-title"><i class="iconfont icon-dianying"></i> 内容版块</div>
					<div class="content-block" v-html="detail.content"></div>
				</div>
				<div class="section-card" v-if="detail.text_intro" id="sec-text">
					<div class="section-title"><i class="iconfont icon-dianying"></i> 文字说明</div>
					<div class="text-block">{{ detail.text_intro }}</div>
				</div>
			</div>

			<!-- 关联方案：案例详情的 html 对应方案 -->
			<div class="section-card" v-if="relatedRecords.length" id="sec-rel">
				<div class="section-title"><i class="iconfont icon-shipinbofangyingpian"></i> 关联方案</div>
				<div class="rel-item" v-for="r in relatedRecords" :key="r.id">
					<span>{{ r.main || r.type }}</span>
					<button class="btn-link" v-if="r.type === 'html'" @click="goScheme(r.id)">查看方案</button>
					<button class="btn-link" v-if="r.type === 'page'" @click="goBudget(r.id)">查看报价</button>
				</div>
			</div>
		</div>

		<Footernew />
	</div>
</template>

<script>
import Headernew from '@/components/Headernew.vue'
import Footernew from '@/components/Footernew.vue'
import Comment from '@/components/comment.vue'
import gotop from '@/components/gotop.vue'
import PdfViewer from '@/components/PdfViewer.vue'

export default {
	name: 'caseDetail',
	components: { Headernew, Footernew, Comment, gotop, PdfViewer },
	data() {
		return { detail: null }
	},
	created() {
		this.load()
	},
	computed: {
		relatedRecords() {
			const h = this.detail && this.detail.html
			return Array.isArray(h) ? h : []
		},
	},
	methods: {
		load() {
			this.$axios.get(this.$api + '/getWorksCaseById/' + this.$route.query.id)
				.then(res => { this.detail = res.data.result || null })
				.catch(err => { console.log(err) })
		},
		goScheme(id) { this.$router.push({ path: '/schemeDetail', query: { id } }) },
		goBudget(id) { this.$router.push({ path: '/budgetDetail', query: { id } }) },
		goList() { this.$router.push('/projectProposal') },
		scrollToSection(id) {
			const el = document.getElementById(id)
			if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
		},
	},
}
</script>

<style scoped>
.videolist-banner { width: 100%; height: 300px; background-image: url(https://lubanhui1.oss-cn-beijing.aliyuncs.com/htkj/imgs/mediabanner.jpg); background-size: 100% 100%; position: relative; }
.bannertop-title { width: 100%; position: absolute; left: 0; top: 45%; }
.bannertop-title div:nth-of-type(1) { width: 80%; margin: 0 auto; font-size: 38px; color: #fff; font-weight: bold; }
.bannertop-title div:nth-of-type(2) { width: 48%; margin: 14px auto 0; font-size: 18px; color: #fff; text-align: right; letter-spacing: 2px; }

.app-container { max-width: 900px; margin: 0 auto; padding: 2rem 1.5rem 4rem; text-align: left; }
.breadcrumb { display: flex; align-items: center; gap: .5rem; font-size: .9rem; color: #94a3b8; margin-bottom: 1.5rem; padding-bottom: .75rem; border-bottom: 1px solid #e9edf4; }
.breadcrumb .sep { color: #cbd5e1; }
.breadcrumb .clickable { cursor: pointer; color: #2563eb; font-weight: 500; }
.breadcrumb .clickable:hover { color: #1d4ed8; text-decoration: underline; }
.breadcrumb .current { color: #1e293b; font-weight: 500; }

.detail-card { box-sizing: border-box; max-width: 700px; margin: 0 auto; padding: 1rem 1.5rem; background: #fff; border-radius: 14px; border: 1px solid #eef2f6; box-shadow: 0 4px 12px rgba(0,0,0,.04); }
.detail-card .field { display: flex; padding: .6rem 0; border-bottom: 1px solid #f1f5f9; }
.detail-card .field:last-child { border-bottom: none; }
.detail-card .field .label { width: 90px; font-weight: 500; color: #64748b; flex-shrink: 0; font-size: .9rem; }
.detail-card .field .value { flex: 1; color: #0a2540; font-size: .95rem; word-break: break-word; }
.detail-title { font-size: 1.5rem; font-weight: 600; color: #0a2540; margin-bottom: 1rem; display: flex; align-items: center; gap: .5rem; }
.detail-title i { color: #2563eb; }
.value a { color: #2563eb; text-decoration: underline; word-break: break-all; }

.media-block { max-width: 700px; margin: 1.5rem auto 0; display: flex; flex-direction: column; gap: 1rem; }
.section-card { box-sizing: border-box; padding: 1rem 1.5rem; background: #fff; border-radius: 14px; border: 1px solid #eef2f6; box-shadow: 0 2px 8px rgba(0,0,0,.03); }
.section-title { font-size: .95rem; font-weight: 600; color: #0a2540; margin-bottom: .75rem; display: flex; align-items: center; gap: .4rem; }
.section-title i { color: #2563eb; }
.content-block { line-height: 1.7; word-break: break-word; }
.text-block { white-space: pre-wrap; color: #475569; }

/* 版块标签条 */
.section-tabs { max-width: 700px; margin: .5rem auto 1rem; display: flex; flex-wrap: wrap; gap: .5rem; }
.section-tab { background: #f1f5f9; color: #475569; border: 1px solid #e2e8f0; padding: .35rem .9rem; border-radius: 20px; font-size: .85rem; cursor: pointer; transition: all .15s; }
.section-tab:hover { background: #dbeafe; color: #2563eb; border-color: #2563eb; }
.detail-card, .section-card { scroll-margin-top: 90px; }

.rel-item { display: flex; align-items: center; justify-content: space-between; padding: .6rem 1rem; background: #fafcff; border-radius: 10px; border: 1px solid #eef2f6; margin-bottom: .5rem; }
.btn-link { background: #2563eb; color: #fff; border: none; padding: .4rem 1rem; border-radius: 30px; font-weight: 500; font-size: .85rem; cursor: pointer; display: inline-flex; align-items: center; gap: .3rem; transition: background .2s; }
.btn-link:hover { background: #1d4ed8; }

.empty-state { text-align: center; padding: 3rem 1rem; color: #94a3b8; }
.empty-state i { font-size: 2.5rem; opacity: .3; margin-bottom: .5rem; }

@media (max-width: 768px) {
	.videolist-banner { height: 220px; }
	.bannertop-title { top: 48%; }
	.bannertop-title div:nth-of-type(1) { font-size: 24px; }
	.bannertop-title div:nth-of-type(2) { font-size: 14px; width: 80%; }
	.app-container { padding: 1rem .75rem; }
	.detail-card { padding: 1rem; }
	.detail-card .field { flex-direction: column; gap: .2rem; }
	.detail-card .field .label { width: auto; }
}
</style>

<style>
@import '../../assets/css/alibaba.css';
</style>